module.exports = __webpack_public_path__ + "media/images/common/ico-cart-w-rounded-0b980ad8b7f06f3fc0b396178dbc4865.svg";